export * as Api from './api';

export enum InvestorReportingType {
  Periodic = 'Periodic',
  CustomUpdate = 'Custom Update',
  DeploymentUpdate = 'Deployment Update',
  ExitStatement = 'Exit Statement',
}
